if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        if (!this.form) return;

        this.form.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this)
        );

        this.cartNotification =
          document.querySelector("cart-notification");

        this.cartItems =
          document.querySelector("cart-items");

        this.quickViewWarpper =
          document.getElementById("quickViewWrapper");
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        const submitButton =
          this.querySelector('[type="submit"][name="add"]') ||
          this.querySelector('[type="submit"]');

        if (!submitButton) return;

        /*
         * IMPORTANT:
         * Agar Shopify/theme ne button pehle se disabled rakha hai
         * to request submit nahi hogi.
         */
        if (
          submitButton.disabled ||
          submitButton.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        submitButton.setAttribute("disabled", "disabled");
        submitButton.setAttribute("aria-disabled", "true");
        submitButton.classList.add("loading");

        let config = fetchConfig("javascript");

        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        let formData = new FormData(this.form);

        if (this.cartNotification) {
          formData.append(
            "sections",
            this.cartNotification
              .getSectionsToRender()
              .map((section) => section.id)
          );

          this.cartNotification.setActiveElement(
            document.activeElement
          );
        }

        if (this.cartItems) {
          formData.append(
            "sections",
            this.cartItems
              .getSectionsToRender()
              .map((section) => section.section)
          );
        }

        formData.append(
          "sections_url",
          window.location.pathname
        );

        config.body = formData;

        let addSuccessful = false;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())

          .then((parsedState) => {
            /*
             * Shopify error:
             * e.g. sold out / insufficient inventory
             */
            if (parsedState.status) {
              this.handleErrorMessage(
                parsedState.description ||
                "This item is currently unavailable."
              );

              return;
            }

            addSuccessful = true;

            if (this.cartNotification) {
              this.cartNotification.renderContents(
                parsedState
              );
            }

            if (this.cartItems) {
              this.cartItems.renderContents(
                parsedState
              );
            }

            document
              .querySelector(
                ".product-form__error-message-wrapper"
              )
              ?.classList.add("no-js-inline");
          })

          .catch((e) => {
            console.error(e);
          })

          .finally(() => {
            submitButton.classList.remove("loading");

            /*
             * OLD CODE:
             * submitButton.removeAttribute("disabled");
             *
             * Wo blindly button enable kar raha tha.
             *
             * Ab hum sirf successful Add to Cart ke baad
             * temporary disabled state remove karenge.
             *
             * Agar theme/Shopify button ko sold-out state
             * me rakhta hai to us state ko force-enable
             * nahi karenge.
             */
            if (addSuccessful) {
              const buttonText =
                submitButton
                  .querySelector(".cart--button-text")
                  ?.textContent
                  ?.trim()
                  ?.toLowerCase() || "";

              const soldOut =
                buttonText.includes("sold out") ||
                buttonText.includes("out of stock") ||
                submitButton.classList.contains("sold-out");

              if (!soldOut) {
                submitButton.removeAttribute("disabled");
                submitButton.removeAttribute("aria-disabled");
              }
            }

            this.quickViewWarpper?.classList.remove(
              "show__modal"
            );

            document.body.classList.remove(
              "overflow-hidden"
            );
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper"
          );

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;

          this.errorMessageWrapper.classList.remove(
            "no-js-inline"
          );
        }
      }
    }
  );
}